import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { EltCreateDialogContent } from './EltCreateDialogContent'

interface IEltCreateDialogProps {
  onCreatingChange?: (isCreating: boolean) => void
  show: boolean
  partnerId: string
  fYear: number
  fQuarter: number
  versionSerialNumber: number
  closeDialog: () => void
}

export const EltCreateDialog = ({
  show,
  onCreatingChange,
  partnerId,
  fYear,
  fQuarter,
  versionSerialNumber,
  closeDialog,
}: IEltCreateDialogProps) => {
  const contentProps = useMemo(
    () => ({ partnerId, fYear, fQuarter, versionSerialNumber, closeDialog, onCreatingChange }),
    [partnerId, fYear, fQuarter, versionSerialNumber, closeDialog, onCreatingChange]
  )

  return (
    <ModalDialog
      size="xs"
      content={EltCreateDialogContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}

EltCreateDialog.displayName = 'EltCreateDialog'
